import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Megaphone, Bell, Tag, Percent, Truck, ShieldCheck, IndianRupee, Headset, Star, Sparkles, Award, Heart,
  Clock, Package, Leaf, Zap, Gift, ThumbsUp, BadgeCheck, ShoppingBag, Phone, MapPin,
  Thermometer, Wind, Droplets, Shirt, Snowflake, Flame, Recycle, Waves,
} from "lucide-react";
import { isWhyUsEmoji } from "@/lib/whyUsIcons";
import { makeHref } from "./StorefrontNav";

const ICONS = {
  Megaphone, Bell, Tag, Percent, Truck, ShieldCheck, IndianRupee, Headset, Star, Sparkles, Award, Heart,
  Clock, Package, Leaf, Zap, Gift, ThumbsUp, BadgeCheck, ShoppingBag, Phone, MapPin,
  Thermometer, Wind, Droplets, Shirt, Snowflake, Flame, Recycle, Waves,
};

export function announcementSlides(ann) {
  const a = ann || {};
  const raw = Array.isArray(a.slides) ? a.slides : [];
  const cleaned = raw.filter((s) => s && String(s.text || "").trim());
  if (cleaned.length) return cleaned;
  if (String(a.text || "").trim()) {
    return [{ text: a.text, link: a.link || "", icon: a.icon === undefined ? "Megaphone" : (a.icon || "") }];
  }
  return [];
}

function SlideIcon({ name, className }) {
  if (!name) return null;
  if (isWhyUsEmoji(name)) return <span className="text-sm leading-none flex-shrink-0" aria-hidden>{name}</span>;
  const C = ICONS[name];
  if (!C) return null;
  return <C className={className} />;
}

export default function AnnouncementBar({ ann, modern, base }) {
  const slides = useMemo(() => announcementSlides(ann), [ann]);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    setIdx(0);
  }, [slides.length]);
  useEffect(() => {
    if (slides.length < 2) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % slides.length), 4000);
    return () => clearInterval(t);
  }, [slides.length]);
  if (!ann?.enabled || !slides.length) return null;
  const s = slides[idx] || slides[0];
  const icon = s.icon !== undefined && s.icon !== null ? s.icon : (ann.icon === undefined ? "Megaphone" : (ann.icon || ""));
  return (
    <div className="py-2.5 text-[13px] font-semibold tracking-wide" style={{ background: ann.bg_color || (modern ? "#111111" : "#0F172A"), color: ann.text_color || "#FFFFFF" }} data-testid="store-announcement">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-2 text-center min-h-[1.25rem]">
        <SlideIcon name={icon} className="w-4 h-4 flex-shrink-0 opacity-90" />
        {s.link ? (
          <Link to={makeHref(base, s.link)} className="hover:underline underline-offset-2" data-testid="store-announcement-text">{s.text}</Link>
        ) : (
          <span data-testid="store-announcement-text">{s.text}</span>
        )}
      </div>
    </div>
  );
}
